import useValidatedSearchParams from '../../../../router/useValidatedSearchParams';
import { Filter } from './Filters';

type UseFiltersProps<T> = {
  filters?: Filter<T>[];
  data: T[];
};

const useFilters = <T>({ filters = [], data }: UseFiltersProps<T>) => {
  const { validatedParams } = useValidatedSearchParams();

  const activeFilters = filters?.filter(({ key }) => validatedParams[key]);

  return activeFilters?.length > 0
    ? data?.filter((record) =>
        activeFilters.every(({ match, key }) => {
          const value = validatedParams[key];
          return typeof value === 'string' ? match(record, value) : true;
        })
      )
    : data;
};

export default useFilters;
